import { canAccessPensionCalculators } from "../../Tools/PensionCalculators/access";
import { ReactComponent as DashboardIcon } from "../../../assets/icons/navIcons/MyDashboard.svg";
import {
  canAccessMyPayments,
  canViewMyPaymentsGroup,
} from "../../Tools/MyPayments/access";
import { ReactComponent as MembersHub } from "../../../assets/icons/navIcons/MembersHub.svg";
import { ReactComponent as AMLIcon } from "../../../assets/icons/navIcons/check2.svg";
import { ReactComponent as ToolsCalculators } from "../../../assets/icons/navIcons/ToolsCalculators.svg";
import { ReactComponent as LOAToolkit } from "../../../assets/icons/navIcons/LOAResources.svg";
import { ReactComponent as MarketingPromotions } from "../../../assets/icons/navIcons/MarketingPromotions.svg";
import { ReactComponent as PortalAdmin } from "../../../assets/icons/Icon-Members hub.svg";

import { ReactComponent as ATRProfilerIcon } from "../../../assets/icons/tools/ATRProfiler.svg";
import { ReactComponent as CashflowModellerIcon } from "../../../assets/icons/tools/CashflowModeller.svg";
import { ReactComponent as DccIcon } from "../../../assets/icons/tools/DebtSense.svg";
import { ReactComponent as ProCeding } from "../../../assets/icons/tools/ProCeding.svg";
import { ReactComponent as ProviderIndex } from "../../../assets/icons/tools/ProviderIndex.svg";
import { ReactComponent as FinancialPromotions } from "../../../assets/icons/tools/FinancialPromotions.svg";
import { ReactComponent as MyPayments } from "../../../assets/icons/navIcons/Finance.svg";

import { ReactComponent as DashboardIconCollapsable } from "../../../assets/icons/navIcons/CollapseMyDashboard.svg";
import { ReactComponent as MembersHubCollapsable } from "../../../assets/icons/navIcons/CollapseMembersHub.svg";
import { ReactComponent as AMLIconCollapsable } from "../../../assets/icons/navIcons/Collapsecheck2.svg";
import { ReactComponent as ToolsCalculatorsCollapsable } from "../../../assets/icons/navIcons/CollapseToolsCalculators.svg";
import { ReactComponent as LOAToolkitCollapsable } from "../../../assets/icons/navIcons/CollapseToolkit.svg";
import { ReactComponent as MarketingPromotionsCollapsable } from "../../../assets/icons/navIcons/CollapseMarketingPromotions.svg";
import { ReactComponent as MyPaymentsCollapsable } from "../../../assets/icons/navIcons/CollapseFinance.svg";

const normaliseList = (list = []) =>
  Array.isArray(list)
    ? list.map((item) => String(item).trim().toLowerCase())
    : [];

const normaliseValue = (value) => String(value).trim().toLowerCase();

export const getPortalSectionConfig = ({
  userRole,
  userPermissions = [],
  adviserStatus = [],
  adminStatus = [],
  canSeeAML = false,
}) => {
  const permissions = normaliseList(userPermissions);
  const adviserStatuses = normaliseList(adviserStatus);
  const adminStatuses = normaliseList(adminStatus);

  const hasPermission = (...allowed) =>
    allowed.some((permission) =>
      permissions.includes(normaliseValue(permission)),
    );

  // const canSeeAnnouncements =
  //   userRole === "Advisers" ||
  //   userRole === "Staff" ||
  //   ((userRole === "Administrators" || userRole === "External") &&
  //     hasPermission("NSD"));

  const hasAdviserStatus = (...allowed) =>
    allowed.some((status) => adviserStatuses.includes(normaliseValue(status)));

  const hasAdminStatus = (...allowed) =>
    allowed.some((status) => adminStatuses.includes(normaliseValue(status)));

  const role = String(userRole || "")
    .trim()
    .toLowerCase();

  const isAdviser = role === "advisers";
  const isStaff = role === "staff";
  const isAdministrator = role === "administrators";
  const isExternal = role === "external";

  const canSeeAnnouncements =
    isAdviser ||
    isStaff ||
    ((isAdministrator || isExternal) && hasPermission("NSD"));

  const canSeeMembersHub = !isExternal || (isExternal && hasPermission("NSMH"));

  const canSeeATR =
    isStaff ||
    (isAdviser && hasAdviserStatus("FP")) ||
    (isAdministrator && hasAdminStatus("NSFP"));

  const canSeeCashflow =
    (isStaff &&
      hasPermission("Compliance", "Paraplanning", "Compliance Support")) ||
    (isAdviser && hasAdviserStatus("FP", "NAP")) ||
    (isAdministrator && hasAdminStatus("NSFP"));

  const canSeeDebtSense =
    (isStaff &&
      hasPermission("Compliance", "Paraplanning", "Compliance Support")) ||
    (isAdviser && hasAdviserStatus("MA", "NAP")) ||
    (isAdministrator && hasAdminStatus("NSMA"));

  const canSeeToolsAndCalculators =
    canSeeATR ||
    canSeeCashflow ||
    canSeeDebtSense ||
    canAccessPensionCalculators(userRole, userPermissions);

  const canSeeFinancialPromotions =
    isAdviser ||
    isStaff ||
    (isAdministrator && (hasPermission("NSM") || hasAdminStatus("NSM"))) ||
    (isExternal && hasPermission("NSM"));

  const canSeeProCeding =
    (isStaff &&
      hasPermission("Compliance", "Paraplanning", "Compliance Support")) ||
    (isAdviser && hasAdviserStatus("FP", "NAP")) ||
    (isAdministrator && hasAdminStatus("NSFP"));

  const canSeeProviderIndex =
    (isStaff &&
      hasPermission("Compliance", "Paraplanning", "Compliance Support")) ||
    (isAdviser && hasAdviserStatus("FP", "NAP")) ||
    (isAdministrator && hasAdminStatus("NSFP"));

  const canSeePortalAdministration =
    isStaff &&
    (hasPermission("Administrator") || hasPermission("Portal Administration"));

  const canSeeLoaTrackerAndAnalysis = canSeeProCeding || canSeeProviderIndex;

  // const canSeePortalAdministration =
  //   userRole === "Staff" && hasPermission("Administrator");

  return {
    "my-dashboard": {
      title: "My Dashboard",
      show: canSeeAnnouncements,
      route: "/my-dashboard",
      navIcon: DashboardIcon,
      responsiveIcon: DashboardIconCollapsable,
      matchRoutes: ["/my-dashboard", "/announcements"],
      cards: [
        {
          label: "Announcements",
          description: "View important updates and notices",
          route: "/my-dashboard",
          icn: DashboardIcon,
        },
      ],
    },
    "business-summary": {
      title: "Business Summary",
      show: canAccessMyPayments(userRole, userPermissions),
      route: "/business-summary",
      navIcon: MyPayments,
      responsiveIcon: MyPaymentsCollapsable,
      matchRoutes: ["/business-summary", "/my-payments", "/my-entries"],
      cards: canViewMyPaymentsGroup(userRole, userPermissions)
        ? [
            {
              label: "Group Payments",
              description: "View current-period group payments",
              route: "/business-summary",
              icn: MyPayments,
            },
          ]
        : [],
    },
    "members-hub": {
      title: "Members Hub",
      show: canSeeMembersHub,
      route: "/members-hub",
      navIcon: MembersHub,
      responsiveIcon: MembersHubCollapsable,
      matchRoutes: ["/members-hub"],
      cards: [
        {
          label: "Members Hub",
          description: "Access files, documents and member resources",
          route: "/members-hub",
          icn: MembersHub,
        },
      ],
    },

    check2: {
      title: "check²",
      show: canSeeAML,
      route: "/check²",
      navIcon: AMLIcon,
      responsiveIcon: AMLIconCollapsable,
      matchRoutes: ["/check²", "/check2", "/aml", "/new-check"],
      cards: [
        {
          label: "check²",
          description:
            "Run and review AML, ID verification and screening checks",
          route: "/check²",
          icn: AMLIcon,
        },
      ],
    },

    "tools-calculators": {
      title: "Tools & Calculators",
      show: canSeeToolsAndCalculators,
      route: "/portal/tools-calculators",
      navIcon: ToolsCalculators,
      responsiveIcon: ToolsCalculatorsCollapsable,
      matchRoutes: [
        "/portal/tools-calculators",
        "/atr-profiler",
        "/cashflow-modeller",
        "/cashflow-modeller-dashboard",
        "/debt-sense",
      ],
      cards: [
        ...(canSeeATR
          ? [
              {
                label: "ATR Profiler",
                description:
                  "Attitude to Risk Profiler to understand client risk tolerance",
                route: "/atr-profiler",
                icn: ATRProfilerIcon,
              },
            ]
          : []),

        ...(canSeeCashflow
          ? [
              {
                label: "Cashflow Modeller",
                description:
                  "Financial forecasting tool to help clients plan for the future",
                route: "/cashflow-modeller-dashboard",
                icn: CashflowModellerIcon,
              },
            ]
          : []),

        ...(canSeeDebtSense
          ? [
              {
                label: "DebtSense",
                description: "Debt consolidation calculator",
                route: "/debt-sense",
                icn: DccIcon,
              },
            ]
          : []),
        // ...(canAccessPensionCalculators(userRole, userPermissions)
        //   ? [
        //       {
        //         label: "Pension Calculators",
        //         description:
        //           "Pension case checking calculators for tax-free cash, retirement income, yields and annuity comparisons.",
        //         route: "/portal/tools-calculators/pension-calculators",
        //         icn: ToolsCalculators,
        //       },
        //     ]
        //   : []),
      ],
    },

    "loa-toolkit": {
      title: "LOA Toolkit",
      show: canSeeLoaTrackerAndAnalysis,
      route: "/portal/loa-toolkit",
      navIcon: LOAToolkit,
      responsiveIcon: LOAToolkitCollapsable,
      matchRoutes: [
        "/portal/loa-toolkit",
        "/pro-ceding",
        "/provider-index",
        "/loa",
      ],
      cards: [
        ...(canSeeProCeding
          ? [
              {
                label: "ProCeding",
                description:
                  "Extract and analyse key data from returned ceding schemes",
                route: "/pro-ceding/dashboard",
                icn: ProCeding,
              },
            ]
          : []),

        ...(canSeeProviderIndex
          ? [
              {
                label: "Provider Index",
                description:
                  "Directory of pension and investment providers and LOA guidelines",
                route: "/provider-index",
                icn: ProviderIndex,
              },
            ]
          : []),
      ],
    },

    "marketing-promotions": {
      title: "Marketing & Promotions",
      show: canSeeFinancialPromotions,
      route: "/portal/marketing-promotions",
      navIcon: MarketingPromotions,
      responsiveIcon: MarketingPromotionsCollapsable,
      matchRoutes: ["/portal/marketing-promotions", "/financial-promotions"],
      cards: [
        {
          label: "Financial Promotions",
          description: "Submit promotions for compliance approvals",
          route: "/financial-promotions",
          icn: FinancialPromotions,
        },
      ],
    },

    "portal-administration": {
      title: "Portal Administration",
      show: canSeePortalAdministration,
      route: "/portal/portal-administration",
      navIcon: MembersHub,
      responsiveIcon: MembersHubCollapsable,
      matchRoutes: ["/portal/portal-administration", "/portal-access-audit"],
      cards: [
        {
          label: "Access Audit",
          description:
            "Review which users can access each portal section and why",
          route: "/portal-access-audit",
          icn: MembersHub,
        },
      ],
    },
  };
};
